@if (isInCart()) {
  <ui-quantity-counter
    class="round"
    (remove)="remove.emit()"
    [loading]="loading()"
    [value]="amount()"
    (valueChange)="amount.set($event)"
    [showRemoveWhenQuantityIsMinimum]="true"
    [debounceMs]="quantityChangeDebounceMs()"
    [max]="quantityMax()"
    [min]="quantityMin()"
  >
  </ui-quantity-counter>
} @else {
  <ui-button (clicked)="add.emit()" [disabled]="disabled()" [loading]="loading()">
    <ui-icon faName="cart-shopping" faStyle="light"></ui-icon>
    <ui-icon faName="plus" faStyle="solid"></ui-icon>
  </ui-button>
}
